import { Alert, Flex } from 'antd';

import { useNavigate, useSearchParams } from '@suntex.core/nav';
import { Button } from '@suntex.fim/ui';

/**
 * Auth error page that displays authentication errors
 */
export function AuthErrorPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const message =
    searchParams.get('message') || 'An authentication error occurred';
  const code = searchParams.get('code');

  return (
    <Flex vertical align="center" gap={24} style={{ padding: '40px 20px' }}>
      <Alert
        message="Authentication Error"
        description={
          <Flex vertical gap={8}>
            <p>{message}</p>
            {code && (
              <p style={{ fontSize: '12px', color: '#666' }}>
                Error Code: {code}
              </p>
            )}
          </Flex>
        }
        type="error"
        showIcon
        style={{ maxWidth: 600, width: '100%' }}
      />

      <Flex gap={12}>
        <Button
          onClick={() => {
            navigate('/');
          }}
        >
          Return Home
        </Button>
      </Flex>
    </Flex>
  );
}
